import { Button } from "@src/components/ui-components/Buttons/Button/Button";
import { t } from "i18next";
import { AdvancedSelectInput } from "../../../../../components/ui-components/AdvancedSelectInput/AdvancedSelectInput";

import { SystemsAndComponentsUtilities } from "../../../../../utils/systemsAndComponentsUtilities";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";

export class CustomFieldNorwegianStandardDataType extends CustomFieldDataTypeHelper<string> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setData: (data: string | undefined) => void
  ): JSX.Element {
    return (
      <AdvancedSelectInput
        didSelect={(key) => setData(key.id)}
        trigger={
          <Button
            type="secondary"
            backgroundColor="var(--bg-2-color)"
            title={
              (typeof data === "string" && data ? (SystemsAndComponentsUtilities.getOptionWithKey(options.standardID, data)?.title ?? "") : "") +
              "(" +
              t("main.tapToSelect") +
              ")"
            }
            fullWidth
            color="var(--text-color)"
          />
        }
        sections={SystemsAndComponentsUtilities.retrieveSections(options.standardID)}
      />
    );
  }

  getStringRepresentation(data: any | undefined, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    if (typeof data === "string") {
      return SystemsAndComponentsUtilities.getOptionWithKey(options.standardID, data)?.title ?? "";
    }
    return "";
  }
}
